import { Field } from 'formik';
import ConfirmPassword from '../ConfirmPassword';
import { formatPhoneNumber } from '../common';
import GenderDOBComponent from '../GenderDOBComponent';

const PatientRegistrationComponent = ({ disabled, errors, touched, values, handleChange, prefix, handleBlur, editPage, patientRegistration, setFieldValue, dispatch,
    patientEdit, handleReset }) => {

    
    const handlePhoneNumInput = (e, setFieldValue) => {
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        setFieldValue('phoneNo', formattedPhoneNumber);
    };


    return (
        <div className="space-y-6">

            {/* <div>
                <div className='profile-icon-div'><ProfileIcon /></div>
                <div className='upload-btn-div'><button className='upload-btn-div' disabled><UploadIcon className='icon-div'/> Upload Picture</button></div>
            </div> */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="firstname" className="block text-sm font-medium text-gray-700">First Name <span className="text-red-500">*</span></label>
                    <div className="mt-1">
                        {patientRegistration &&
                            <Field
                                type="text"
                                id={`${prefix}-input_firstname`}
                                name="firstname"
                                required
                                onBlur={handleBlur}
                                className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${errors.firstname && touched.firstname ? 'border-red-500' : 'border-gray-300'}`}
                            />}
                        {errors.firstname && touched.firstname ? (
                            <p className="mt-1 text-sm text-red-600">{errors.firstname}</p>
                        ) : null}
                    </div>
                </div>
                <div>
                    <label htmlFor="lastname" className="block text-sm font-medium text-gray-700">Last Name <span className="text-red-500">*</span></label>
                    <div className="mt-1">
                        {patientRegistration &&
                            <Field
                                type="text"
                                id={`${prefix}-input_lastname`}
                                name="lastname"
                                required
                                onBlur={handleBlur}
                                className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${errors.lastname && touched.lastname ? 'border-red-500' : 'border-gray-300'}`}
                            />}
                        {errors.lastname && touched.lastname ? (
                            <p className="mt-1 text-sm text-red-600">{errors.lastname}</p>
                        ) : null}
                    </div>
                </div>
            </div>
            {(patientRegistration || patientEdit) &&
                <GenderDOBComponent
                    errors={errors}
                    values={values}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    prefix={prefix}
                    handleBlur={handleBlur}
                    handleReset={handleReset}
                />

            }
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="userEmail" className="block text-sm font-medium text-gray-700">Email <span className="text-red-500">*</span></label>
                    <div className="mt-1">
                        <Field
                            type="email"
                            id={`${prefix}-input_userEmail`}
                            name="userEmail"
                            disabled={patientEdit}
                            className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${errors.userEmail && touched.userEmail ? 'border-red-500' : 'border-gray-300'}`}
                        />
                        {errors.userEmail && touched.userEmail ? (
                            <p className="mt-1 text-sm text-red-600">{errors.userEmail}</p>
                        ) : null}
                    </div>
                </div>

                <div>
                    <label htmlFor="phoneNo" className="block text-sm font-medium text-gray-700">Phone Number <span className="text-red-500">*</span></label>
                    <div className="mt-1">
                        <Field
                            type="text"
                            id={`${prefix}-input_userPhoneNo`}
                            name="phoneNo"
                            onChange={(e) => handlePhoneNumInput(e, setFieldValue)}
                            className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${errors.phoneNo && touched.phoneNo ? 'border-red-500' : 'border-gray-300'}`}
                        />
                        {errors.phoneNo && touched.phoneNo ? (
                            <p className="mt-1 text-sm text-red-600">{errors.phoneNo}</p>
                        ) : null}
                    </div>
                </div>
            </div>

            {patientRegistration &&
                <div>
                    <ConfirmPassword
                        errors={errors}
                        touched={touched}
                        handleBlur={handleBlur}
                        prefix={prefix}
                    />
                </div>
            }


        </div>
    );

};

export default PatientRegistrationComponent;